export const CATALOG_LOAD = 'CATALOG_LOAD';
export const CATALOG_LOAD_RESULT = 'CATALOG_LOAD_RESULT';

export const CATALOG_INITIAL = 'CATALOG_INITIAL';
export const CATALOG_LOADINGS = 'CATALOG_LOADINGS';
export const CATALOG_INITIAL_RESULT = 'CATALOG_INITIAL_RESULT';

export const CATALOG_PROCESS_ITEM = 'CATALOG_PROCESS_ITEM';
export const CATALOG_PROCESS_ITEMS = 'CATALOG_PROCESS_ITEMS';